import React from "react";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonModal from "../../../components/Common/CommonModal";
import CommonInput from "../../../components/forms/CommonInput";
import PropTypes from "prop-types";
import { handleChange } from "../../../helpers/handleFormChanges";

function EditarTipoModal({
  isOpen,
  setIsOpen,
  valuesHook,
  salvaTipo,
  novoTipo,
}) {
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={values?.uid ? "Editar tipo" : "Novo tipo"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="lg"
      buttons={
        <CommonButton
          key={`salvar-tipo`}
          onClick={() => {
            values?.uid ? salvaTipo() : novoTipo();
          }}
          color="success"
        >
          Salvar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonInput
            id={"categoria"}
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.categoria}
            label="Categoria"
            required
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInput
            id={"chave"}
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.chave}
            label="Chave"
            required
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInput
            id={"valor"}
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.valor}
            label="Valor"
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

EditarTipoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaTipo: PropTypes.func.isRequired,
  novoTipo: PropTypes.func.isRequired,
};

export default EditarTipoModal;
